<template>
    <div>
        <div class="coupon-box" @click="conversionCode">
            <p>优惠券/兑换码</p>
            <div style="display:flex;color:#666;align-items: center;">
                <span v-if="couponPrice==0 && couponPoints==0" class="youhui">兑换享优惠</span>
                <span style="color:#FF355C" v-if="list.length > 0 && couponPrice > 0">{{configInfo.cash_name||'现金'}}:-￥{{couponPrice}}</span>
                <span style="color:#FF355C" v-if="list.length > 0 && couponPoints > 0">&nbsp;&nbsp;{{configInfo.points_price_name||'积分'}}:-{{couponPoints}}</span>
                <span style="color:#FF355C" v-if="list.length > 0 && couponExpress.coupon_freight == 1 && express == 1 && discountExpressFee != 0 && discountExpressFee != '' && discountType==2">&nbsp;&nbsp;运费:-￥{{discountExpressFee}}</span>
                <van-icon name="arrow" style="margin-left:.1rem;font-size:.24rem"/>
            </div>
        </div>
        <van-popup :style="{ height: '70%' }" :lock-scroll='true' closeable v-model="showList" position="bottom">
            <div class="top-box">
                <div style="display:flex;justify-content:space-between">
                    <span style="color:#fff">x</span>
                    <span>优惠券/兑换码</span>
                    <van-icon @click="showList = false" name="cross" size=".3rem" style="padding-right:.2rem"/>
                </div>
            </div>
            <!-- <p style="text-align:center;padding: .2rem 0;">兑换码</p> -->
            <van-search style="margin-top:.6rem" show-action v-model="value" placeholder="请输入兑换码" shape="round" >
                <template #action>
                    <div @click="onExchange(value)" style="color:#FF355C">使用</div>
                </template>
            </van-search>
            <!-- style="margin-top:1.8rem"  -->
            <van-tabs v-model="active" @click="getData" :sticky='true' offset-top='.5rem'>
                <van-tab :title="'可用'+' ('+list.length+')'">
                    <div class="box" :class="list.length>0?'active':'none'">
                        <div v-for="(item,i) in list" :key="i" class="coupon">
                            <div style="display:flex;align-items: center;">
                                <div v-if="item.cp_pd_id != 0" @click="radioCouponBtn" style="margin-right:.2rem">
                                    <van-radio-group v-model="radioCoupon">
                                        <van-radio :name="item.id" checked-color="#FF355C"></van-radio>
                                    </van-radio-group>
                                </div>
                                <div v-else style="margin-right:.2rem">
                                    <van-radio-group v-model="radioCoupon">
                                        <van-radio :name="item.id" disabled="true"></van-radio>
                                    </van-radio-group>
                                </div>
                                <div style="width: 100%;">
                                    <p style="color:#FF355C;font-size:.26rem">{{item.coupon_name}}</p>
                                    <div class="main_code">
                                        <p>{{item.coupon_code}}</p>
                                        <p v-if="item.coupon_code == '' && item.coupon_reduction_type == 0">
                                          {{ '立减' + item.coupon_amount }}
                                        </p>
                                        <p v-if="item.coupon_code == '' && item.coupon_reduction_type == 1">
                                          {{ '满' + item.coupon_full + '减' + item.coupon_amount }}
                                        </p>
                                        <p style="margin-left:.1rem;color:#999">{{(item.start_time).substring(0,10)}} ~ {{(item.end_time).substring(0,10)}}</p>
                                    </div>
                                    <!-- <p v-if="item.coupon_attribute == 300 && item.coupon_freight != 1" style="margin-top: .15rem;">可优惠1款商品（运费自理）</p>
                                    <p v-if="item.coupon_attribute == 300 && item.coupon_freight == 1" style="margin-top: .15rem;">可优惠1款商品（免运费）</p> -->
                                    <p v-if="item.coupon_attribute == 300" style="margin-top: .15rem;">可优惠1款商品</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab :title="'不可用'+' ('+notList.length+')'">
                    <div class="box" :class="notList.length>0?'active':'none'">
                        <div v-for="(item,i) in notList" :key="i" class="coupon">
                            <div style="display:flex;align-items: center;">
                                <div style="margin-right:.2rem">
                                    <van-radio-group v-model="radioCoupon" disabled>
                                        <van-radio name="-1" checked-color="#FF355C"></van-radio>
                                    </van-radio-group>
                                </div>
                                <div style="width: 100%;">
                                    <p style="color:#FF355C;font-size:.26rem">{{item.coupon_name}}</p>
                                    <div class="main_code">
                                        <p>{{item.coupon_code}}</p>
                                        <p style="margin-left:.2rem;color:#999">{{(item.start_time).substring(0,10)}} ~ {{(item.end_time).substring(0,10)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <!-- <van-button class="add-btn" @click="notUse" color="#FF355C" primary type="info" size="small">不使用优惠券</van-button> -->
            <van-goods-action style="width: 94%;margin: 0 auto;">
                <van-goods-action-button type="danger" text="不使用优惠券/兑换码" @click="notUse" color="#FF8C27" />
                <van-goods-action-button @click="showList = false"  color="#FF355C" type="warning" text="完成" />
            </van-goods-action>
            </van-popup>
    </div>
</template>

<script>
    import localStor from '../../utils/ls'
    import { Dialog } from 'vant';
    export default {
        props:['discountExpressFee','discountType','showDataAddress', 'shopCartList'],
        data(){
            return{
                configInfo: JSON.parse(localStorage.getItem("configInfo")) || {},
                showList:false,
                shopCart: localStor.get('result') || [], //购物车传来的商品
                shopDetailId:localStor.get("shopDetailId") || '',
                cartShopArr:localStor.get("result") || [] ,//购物车
                payDetail:localStor.get("payDetail") || {} ,
                cppdId:'',
                list:[],
                notList:[],
                value:'',
                active: 0,
                couponPoints:0,
                couponPrice:0,
                couponFreight:0,
                couponExpress:'',
                radioCoupon:-1,
                couponSta:'',
                express:0,//是否显示优惠运费
                isAuto:1
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            notUse(){
                this.showList = false
                this.radioCoupon = -1
                this.couponPrice = 0
                this.couponPoints = 0
                this.express = 0 //用户承担运费
                this.$emit('notUse')
            },
            radioAutoCouponBtn(){
                this.express = 1
                this.showList = false
                this.couponExpress = this.list.filter((res,i)=>{
                    return this.radioCoupon == res.id
                })[0]
                let obj = this.shopCartList.filter((res,i)=>{
                    return (res.cp_pd_id || res.id) == this.couponExpress.cp_pd_id
                })[0]
                // console.log(obj,this.shopCartList)
                let pdPoints = obj.pd_points * obj.pay_num
                let pdPrice = obj.pd_price * obj.pay_num
                if (obj.is_specs == 1) {
                    if (obj.skuList) {
                        let sku = localStor.get("skuproduc")
                        for(let i = 0;i<obj.skuList.length;i++) {
                            if (obj.skuList[i].cp_sku_id == sku.cp_sku_id) {
                                pdPoints = obj.skuList[i].pd_points * obj.pay_num
                                pdPrice = obj.skuList[i].pd_price * obj.pay_num
                            }
                        }
                    }
                }
                // 先对优惠积分和价格赋值 再进行判断
                this.couponPoints = this.couponExpress.coupon_denomination == 0 ? this.couponExpress.coupon_amount : '0.00'
                this.couponPrice = this.couponExpress.coupon_denomination == 1 ? this.couponExpress.coupon_amount : '0.00'

                // 满减
                if ((this.couponExpress.coupon_attribute == '100' || this.couponExpress.coupon_attribute == '200') && this.couponExpress.coupon_reduction_type == 1) {
                  if (this.couponExpress.coupon_denomination == 0 && pdPoints < Number(this.couponExpress.coupon_full)) {
                    this.notUse()
                    console.log('不满足积分满减条件')
                    return false
                  }
                  if (this.couponExpress.coupon_denomination == 1 && pdPrice < Number(this.couponExpress.coupon_full)) {
                    this.notUse()
                    console.log('不满足现金满减条件')
                    return false
                  }
                }

                // 立减
                if ((this.couponExpress.coupon_attribute == '100' || this.couponExpress.coupon_attribute == '200') && this.couponExpress.coupon_reduction_type == 0) {
                  if ((this.couponExpress.coupon_denomination == 0 && pdPoints == 0) || this.couponExpress.coupon_denomination == 1 && pdPrice == 0) { // 积分
                    this.notUse()
                    // return this.$toast('此商品没有可优惠' + (this.couponExpress.coupon_denomination == 1 ? '现金' : '积分'))
                    console.log('此商品没有可优惠' + (this.couponExpress.coupon_denomination == 1 ? '现金' : '积分'))
                    return false
                  }
                  if (this.couponExpress.coupon_denomination == 0 && pdPoints < Number(this.couponExpress.coupon_amount)) { // 积分
                    console.log('此商品最大可优惠积分' + pdPoints)
                    this.couponPoints = pdPoints
                  }
                  if (this.couponExpress.coupon_denomination == 1 && pdPrice < Number(this.couponExpress.coupon_amount)) { // 现金
                    console.log('此商品最大可优惠现金' + pdPrice)
                    this.couponPrice = pdPrice
                  }
                }
                this.cpPdId = obj.cp_pd_id || obj.id
                let newObj = {}
                newObj.couponPoints = this.couponPoints
                newObj.couponPrice = this.couponPrice
                newObj.exchangeCode = this.radioCoupon
                newObj.cpPdId = this.cpPdId
                newObj.couponExpress = this.couponExpress
                this.$emit('radioCouponBtn',newObj)
                return true
            },
            radioCouponBtn(){
                this.express = 1
                this.showList = false
                this.couponExpress = this.list.filter((res,i)=>{
                    return this.radioCoupon == res.id
                })[0]
                
                let obj = this.shopCartList.filter((res,i)=>{
                    return (res.cp_pd_id || res.id) == this.couponExpress.cp_pd_id
                })[0]
                let pdPoints = obj.pd_points * obj.pay_num
                let pdPrice = obj.pd_price * obj.pay_num
                if (obj.is_specs == 1) {
                    if (obj.skuList) {
                        let sku = localStor.get("skuproduc")
                        for(let i = 0;i<obj.skuList.length;i++) {
                            if (obj.skuList[i].cp_sku_id == sku.cp_sku_id) {
                                pdPoints = obj.skuList[i].pd_points * obj.pay_num
                                pdPrice = obj.skuList[i].pd_price * obj.pay_num
                            }
                        }
                    }
                }
                // 先对优惠积分和价格赋值 再进行判断
                this.couponPoints = this.couponExpress.coupon_denomination == 0 ? this.couponExpress.coupon_amount : '0.00'
                this.couponPrice = this.couponExpress.coupon_denomination == 1 ? this.couponExpress.coupon_amount : '0.00'

                // 满减
                if ((this.couponExpress.coupon_attribute == '100' || this.couponExpress.coupon_attribute == '200') && this.couponExpress.coupon_reduction_type == 1) {
                  if (this.couponExpress.coupon_denomination == 0 && pdPoints < Number(this.couponExpress.coupon_full)) {
                    this.notUse()
                    console.log('不满足积分满减条件')
                    this.$toast('不满足积分满减条件')
                    return false
                  }
                  if (this.couponExpress.coupon_denomination == 1 && pdPrice < Number(this.couponExpress.coupon_full)) {
                    this.notUse()
                    console.log('不满足现金满减条件')
                    this.$toast('不满足现金满减条件')
                    return false
                  }
                }

                // 立减
                if ((this.couponExpress.coupon_attribute == '100' || this.couponExpress.coupon_attribute == '200') && this.couponExpress.coupon_reduction_type == 0) {
                  if ((this.couponExpress.coupon_denomination == 0 && pdPoints == 0) || this.couponExpress.coupon_denomination == 1 && pdPrice == 0) { // 积分
                    this.notUse()
                    // return this.$toast('此商品没有可优惠' + (this.couponExpress.coupon_denomination == 1 ? '现金' : '积分'))
                    console.log('此商品没有可优惠' + (this.couponExpress.coupon_denomination == 1 ? '现金' : '积分'))
                    this.$toast('此商品没有可优惠' + (this.couponExpress.coupon_denomination == 1 ? '现金' : '积分'))
                    return false
                  }
                  if (this.couponExpress.coupon_denomination == 0 && pdPoints < Number(this.couponExpress.coupon_amount)) { // 积分
                    console.log('此商品最大可优惠积分' + pdPoints)
                    this.$toast('此商品最大可优惠积分' + pdPoints)
                    this.couponPoints = pdPoints
                  }
                  if (this.couponExpress.coupon_denomination == 1 && pdPrice < Number(this.couponExpress.coupon_amount)) { // 现金
                    console.log('此商品最大可优惠现金' + pdPrice)
                    this.$toast('此商品最大可优惠现金' + pdPrice)
                    this.couponPrice = pdPrice
                  }
                }
                if (this.couponExpress.coupon_attribute == '300' && this.couponExpress.coupon_type == '301') { // 兑换码
                    if(Number(this.couponExpress.coupon_amount) > 0){
                        if (this.couponExpress.coupon_denomination == 2) { // 积分+现金
                            this.couponPoints = obj.pd_points < Number(this.couponExpress.coupon_amount) ? obj.pd_points : Number(this.couponExpress.coupon_amount)
                            this.couponPrice = obj.pd_price < Number(this.couponExpress.coupon_amount) ? obj.pd_price : Number(this.couponExpress.coupon_amount)
                        }
                    }else{
                        this.couponPoints = obj.pd_points
                        this.couponPrice = obj.pd_price
                    }
                    
                }
                if (this.couponExpress.coupon_attribute == '300' && this.couponExpress.coupon_type == '302') { // 兑换码
                  this.couponPoints = obj.pd_points
                  this.couponPrice = obj.pd_price
                }
                this.cpPdId = obj.cp_pd_id || obj.id

                // 拿到购物车的现金 积分 以及 兑换码
                let newObj = {}
                newObj.couponPoints = this.couponPoints
                newObj.couponPrice = this.couponPrice
                newObj.exchangeCode = this.radioCoupon
                newObj.cpPdId = this.cpPdId
                newObj.couponExpress = this.couponExpress
                this.$emit('radioCouponBtn',newObj)
            },
            // 兑换码
            conversionCode(){
                if (this.showDataAddress == 'hideAddress') {
                  this.$toast('填写地址后才可以使用兑换码哦~')
                  return
                }
                this.showList = true
            },
            // 兑换优惠券回调 兑换按钮
            onExchange(code) {
                if(code==''){
                    this.$toast('请先填写兑换码哦..')
                    return
                }
                this.$axios({
                    method: "POST",
                    url: "/coupon/bindCode",
                    data: {
                        couponCode: code,
                    },
                    success: data => {
                        if (data.data.status == 'success') {
                            this.$toast('绑定成功哦..')
                            this.getData()
                        } else {
                            console.log(data.data.code)
                            if (data.data.code === 10057) {
                              this.showCode10057(code, data.data.message)
                            } else {
                              this.$toast(data.data.message)
                            }
                        }
                    }
                });
            },
            showCode10057(code, msg) {
              this.$axios({
                method: "POST",
                url: "/coupon/order",
                data: {
                  couponCode: code,
                },
                success: data => {
                  if (data.data.status == 'success') {
                    Dialog.confirm({
                      title: '提示',
                      message: `${ msg }是否前往该订单？`,
                    })
                    .then(() => {
                      // on confirm
                      console.log('Y')
                      localStor.save("orderDetail", data.data.data);
                      this.$router.push({ path: '/orderDetail', query: { fromCode: 1} })
                    })
                    .catch(() => {
                      // on cancel
                      console.log('N')
                    });
                  } else {
                    this.$toast(data.data.message)
                  }
                }
              });
            },
            getData(){
                if( this.$route.query.path != 'ShoppingCart' && ( this.$route.query.path != 'shopAddress'|| JSON.stringify(this.shopCart)=='{}') ){
                    this.cppdId = this.shopDetailId
                }else{
                    this.cppdId = this.cartShopArr.map(res=>{
                        return res.cp_pd_id
                    })
                    this.cppdId = this.cppdId.join(',')
                }
                this.$axios({
                    method: "POST",
                    url: "/coupon/use/list",
                    data: {
                        cpPdId: this.cppdId
                    },
                    success: data => {
                        if (data.data.status == 'success') {
                          if (data.data.data.constructor === Object) {
                            this.list = data.data.data.useList
                            this.notList = data.data.data.notList
                            var max;
                            for(var i=0; i<this.list.length; i++){
                                for(var j=i; j<this.list.length; j++){
                                    if(parseFloat(this.list[i]['coupon_amount']) < parseFloat(this.list[j]['coupon_amount'])){
                                        max=this.list[j];
                                        this.list[j]=this.list[i];
                                        this.list[i]=max;
                                    }
                                }
                            }
                            if (this.isAuto == 1 && !this.showList) {
                                for(var i = 0; i < this.list.length; i++){
                                    this.radioCoupon = this.list[i].id
                                    let rs = this.radioAutoCouponBtn()
                                    if(rs) break;
                                }
                            }
                          }
                        } else {
                            this.$toast(data.data.message)
                        }
                    }
                });
            },
        }
    }
</script>

<style scoped>
.coupon-box{
    background:#fff;
    padding: .2rem;
    display:flex;
    justify-content: space-between;
}
.add-btn{
    position:fixed;
    bottom:.2rem;
    height:.75rem;
    line-height: .75rem;
    color: rgb(255, 255, 255);
    background: #FF8C27;
    border-color: #FF8C27;
    width: 95%;
    margin:0 2.5%;
    border-radius: .08rem;
}
.box{
    background: #F6F6F6;
    color: #333;
}
.active{
    padding: .2rem 0;
    margin-bottom: 1rem;
}
.coupon{
    padding: .2rem;
    background: #fff;
    margin: .2rem;
}
.main_code{
    display:flex;
    margin-top:.2rem;
    font-size:.24rem ;
    color: #333;
}
.top-box{
    position: fixed;
    z-index: 99;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: .2rem 0;
}
.youhui{
    color:#ff355b;
    border:.01rem solid #ff6280;
    background:#ffe5e7;
    padding:.02rem .1rem;
    font-size: .2rem
}
</style>



// WEBPACK FOOTER //
// src/components/address/ConversionCode.vue